import {AnalyticsEventHandler} from "../../../../../infrastructure/handlers/analytics-event-handler";
import {AnalyticsService} from "../../../../../third-party-services/analytics/analytics-service";
import {LIVE_STREAMING_MODULE} from "../live-streaming-widget.consts";
import {LiveStreamingDisplayEvent} from "../models/live-streaming.display-event";

export class LiveStreamingDisplayEventHandler extends AnalyticsEventHandler {
  type = LIVE_STREAMING_MODULE.ACTION_TYPES.onDisplayEvent;

  static injectables = [AnalyticsService];

  constructor(analyticsService: AnalyticsService) {
    super(analyticsService);

    this.eventType = LiveStreamingDisplayEvent;
  }
}
